//jsxhook

import { ErrorCard as _ErrorCard } from "@sixty-six-north/ui-system"
import React, { useEffect, useState } from "react"
import { Box } from "theme-ui"
import { useErrorMessage, useTypedErrorApi } from "./ErrorHooks"
import { ErrorType } from "./ErrorType"

export const ErrorCard: React.FC<{
  error: ErrorType
  clearAfterDisplay?: boolean
  clearAfterUnload?: boolean
}> = ({ error, clearAfterDisplay = false, clearAfterUnload = false }) => {
  const message = useErrorMessage(error)

  const [localMessage, setLocalMessage] = useState(message)

  const api = useTypedErrorApi(error)

  useEffect(() => {
    if (message && message !== localMessage) {
      setLocalMessage(message)
    }

    if (clearAfterDisplay) {
      api.clear()
    }
    return () => {
      if (clearAfterUnload) {
        api.clear()
        setLocalMessage(undefined)
      }
    }
  }, [message])

  if (localMessage) {
    return (
      <Box sx={{ marginBottom: 24 }}>
        <_ErrorCard title={localMessage.title} message={localMessage.message} />
      </Box>
    )
  } else {
    return null
  }
}
